
import { defineComponent } from "vue";
/* import KTNotificationsMenu from "@/layout/header/partials/NotificationsMenu.vue"; */
/* import KTQuickLinksMenu from "@/layout/header/partials/QuickLinksMenu.vue"; */
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { CookieComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "topbar",
  components: {
    /* KTNotificationsMenu, */
    /* KTQuickLinksMenu, */
    KTUserMenu,
  },
  computed: {
    userName() {
      if (CookieComponent.get("userData") != undefined)
        return JSON.parse(CookieComponent.get("userData") as string).cHoTen;
      else return "test";
    },
  },
});
